/**
 * @format
 */

import React, { useEffect, useState } from 'react';
import moment from 'moment';
import LoadingIndicator from '../../components/loadingIndicator';
import * as routes from '../../routes';
import { getAppointmentByReferenceId, getCancelledAppointmentByReferenceId } from '../../actions/appointmentActions';
import {
	startPatientSearchProcess,
	clearBookingContext,
	clearAgentInstructions,
	startBookingProcess,
	setCancelRescheduleActionReferrer,
} from '../../actions/rd2RefactorActions';
import AppointmentDetailsOverview from '../../components/appointment/appointmentDetailsOverview';
import * as guidedResponseActions from '../../actions/guidedResponseActions';
import { APPOINTMENT_DETAILS } from 'constants/actionReferrer';
import { useAppDispatch, useAppSelector } from "../../store";
import { withRouter } from '../../components/hoc';
import { Alert } from 'reactstrap';

function AppointmentDetailsView(props: any) {

	const [error, setError] = useState<string>('');
	const [isDetailsLoading, setIsDetailsLoading] = useState<boolean>(false);
	const [isRescheduled, setIsRescheduled] = useState<boolean>(false);
	const [pastModal, setPastModal] = useState<boolean>(false);
	const [previousAppointmentModal, setPreviousAppointmentModal] = useState<boolean>(false);
	const [rescheduledAppointmentDetails, setRescheduledAppointmentDetails] = useState<any>({});
	const [rescheduleMethod, setRescheduleMethod] = useState<string>('');

	const activeCareOrder: any = useAppSelector((state: any) => state.careOrder);
	const activePatient: any = useAppSelector((state: any) => state.activePatient);
	const agentInstructions: any = useAppSelector((state: any) => state.appointment.agentInstructions);
	const appointmentManagementConfig: any = useAppSelector((state: any) => state.config.appointmentManagement);
	const availabilitySearchConfig: any = useAppSelector((state: any) => state.config.availabilitySearch);
	const cancelRescheduleInfo: any = useAppSelector((state: any) => state.appointment.cancelRescheduleInfo);
	const decisionSupportOutput: any = useAppSelector((state: any) => state.decisionSupport);
	const details: any = useAppSelector((state: any) => state.appointment.details);
	const enableRequestAppointment: any = useAppSelector((state: any) => state.config.system.enableRequestAppointment);
	const enableDecisionSupportHistory: any = useAppSelector((state: any) => state.config.decisionSupport.enableDecisionSupportHistory);
	const isGroupNumberActive: any = useAppSelector((state: any) => state.config.system.isGroupNumberActive);
	const isGroupNumberRequired: any = useAppSelector((state: any) => state.config.system.isGroupNumberRequired);
	const isMemberIdActive: any = useAppSelector((state: any) => state.config.system.isMemberIdActive);
	const isMemberIdRequired: any = useAppSelector((state: any) => state.config.system.isMemberIdRequired);
	const memberIdFieldLabel: any = useAppSelector((state: any) => state.config.system.memberIdFieldLabel);
	const providerFieldConfig: any = useAppSelector((state: any) => state.config.provider);
	const referralSiteId: any = useAppSelector((state: any) => state.auth.referralSiteId);
	const schedulingConfig: any = useAppSelector((state: any) => state.config.scheduling);
	const sessionQuestionsAndAnswersInfo: any = useAppSelector((state: any) => state.decisionSupport.sessionQuestionsAndAnswersInfo);
	const showInsuranceOnAppointmentDetails: any = useAppSelector((state: any) => state.config.scheduling.showInsuranceOnAppointmentDetails);
	const showInsuranceOnBookAppointment: any = useAppSelector((state: any) => state.config.scheduling.showInsuranceOnBookAppointment);
	const showProviderResponseApptDetails: any = useAppSelector((state: any) => state.config.scheduling.showProviderResponseApptDetails);
	const showProviderResponsePatientHistory: any = useAppSelector((state: any) => state.config.scheduling.showProviderResponsePatientHistory);
	const showReasonForVisitApptDetails: any = useAppSelector((state: any) => state.config.scheduling.showReasonForVisitApptDetails);
	const token: any = useAppSelector((state: any) => state.auth.token);
	const useDecisionSupport: any = useAppSelector((state: any) => state.config.decisionSupport.useDecisionSupport);
	const routePrefix: any = useAppSelector((state: any) => state.config.instance.routePrefix);

	const dispatch = useAppDispatch();

	const getSessionQuestionsAndAnswers = (decisionSupportSessionId: string) => {
		if (decisionSupportSessionId) {
			dispatch(guidedResponseActions.getSessionQuestionsAndAnswers(decisionSupportSessionId)).then(() => {
				setIsDetailsLoading(false);
			});
		}
		else {
			setIsDetailsLoading(false);
		}
	}

	const appointmentDetails = async (referenceId: string) => {
		setIsDetailsLoading(true);
		if (props.isCancelled) {
			dispatch(getCancelledAppointmentByReferenceId(referenceId))
				.then((response: any) => {
					if (response.error) {
						setError('An error occurred while trying to get the appointment details.');
					}

					const decisionSupportSessionId = response.payload?.data?.decisionSupportSessionId;
					getSessionQuestionsAndAnswers(decisionSupportSessionId);
				})
				.catch((err: any) => {
					setError('Error');
				});
		}
		else {
			dispatch(getAppointmentByReferenceId(referenceId))
				.then((response: any) => {
					if (response.error) {
						setError('An error occurred while trying to get the appointment details.');
					}

					const decisionSupportSessionId = response.payload?.data?.decisionSupportSessionId;
					getSessionQuestionsAndAnswers(decisionSupportSessionId);
				})
				.catch((err: any) => {
					setError('Error');
				});
		}
	};

	const newSearch = ()=> {
		dispatch(startPatientSearchProcess(routePrefix));
	}

	const bookAnotherAppointment = () => {
		dispatch(clearBookingContext());
		dispatch(clearAgentInstructions());
		dispatch(
			startBookingProcess(
				activeCareOrder,
				decisionSupportOutput,
				availabilitySearchConfig,
				activePatient.details,
				useDecisionSupport,
				routePrefix,
			),
		);
	}

	const togglePastModal = () => {
        setPastModal(!pastModal);
	};

	const verifyFuture = () => {
		return moment.utc(details.appointmentDateTimeUtc).isAfter();
	};

	const handleCancelClick = () => {
		if (verifyFuture()) {
			dispatch(routes.cancelAppointment(routePrefix, details.referenceId));
		} else {
			togglePastModal();
		}
	};

	const handleEditClick = (e: any) => {
		e.preventDefault();
		dispatch(routes.appointmentEdit(routePrefix, details.referenceId));
	};

	const handlePreviousDetailsClick = (e: any) => {
		e.preventDefault();
		setPreviousAppointmentModal(true);
	};

	const togglePreviousAppointmentDetailsModal = () => {
		setPreviousAppointmentModal(!previousAppointmentModal);
	}

	const handleNewSearchClick = (e: any) => {
		e.preventDefault();
		newSearch();
	};

	const handleBookAnotherAppointmentClick = (e: any) => {
		e.preventDefault();
		bookAnotherAppointment();
	};

	const handleRescheduleClick = () => {
		dispatch(setCancelRescheduleActionReferrer(APPOINTMENT_DETAILS));
		dispatch(routes.rescheduleAppointment(routePrefix, details.referenceId));
	};

	useEffect(() => {
		const params = props.params;
		if (cancelRescheduleInfo.previousAppointmentReferenceId !== '') {
			setRescheduledAppointmentDetails(cancelRescheduleInfo.previousAppointmentDetails);
			setIsRescheduled(true);
			setRescheduleMethod(cancelRescheduleInfo.rescheduleMethod);
			
			// Check if the previous appointment was successfully cancelled in the EMR
			if (cancelRescheduleInfo.rescheduleResponse && 
				!cancelRescheduleInfo.rescheduleResponse.isAppointmentCancelled) {
				const baseMessage = schedulingConfig.cancellationFailureMessage || 
					'The previous appointment could not be cancelled in the EMR';
				setError(
					`${baseMessage}. The new appointment has been booked successfully, but you must manually cancel the previous appointment in the provider's scheduling system to avoid double-booking.`
				);
			}
		}
		appointmentDetails(params.referenceId);
	}, [])

	return (
		<>
			{isDetailsLoading && <LoadingIndicator />}
			{error && !isDetailsLoading && <Alert color="danger">{error}</Alert>}
			{!isDetailsLoading && (
				<AppointmentDetailsOverview
					activeCareOrder={activeCareOrder}
					agentInstructions={agentInstructions.agentPostBookingInstructions}
					appointmentManagementConfig={appointmentManagementConfig}
					bookAnotherAppointment={handleBookAnotherAppointmentClick}
					details={details}
					enableDecisionSupportHistory={enableDecisionSupportHistory}
					handleCancelClick={handleCancelClick}
					handleEditClick={handleEditClick}
					handleNewSearchClick={handleNewSearchClick}
					handlePreviousDetailsClick={handlePreviousDetailsClick}
					handleRescheduleClick={handleRescheduleClick}
					navigate={props.navigate}
					isGroupNumberActive={isGroupNumberActive}
					isGroupNumberRequired={isGroupNumberRequired}
					isMemberIdActive={isMemberIdActive}
					isMemberIdRequired={isMemberIdRequired}
					isRescheduled={isRescheduled}
					memberIdFieldLabel={memberIdFieldLabel}
					pastModal={pastModal}
					previousAppointmentModal={previousAppointmentModal}
					providerFieldConfig={providerFieldConfig}
					rescheduledAppointmentDetails={rescheduledAppointmentDetails}
					rescheduleMethod={rescheduleMethod}
					schedulingConfig={schedulingConfig}
					selectedAppointmentReferenceId={details.referenceId}
					sessionQuestionsAndAnswersInfo={sessionQuestionsAndAnswersInfo}
					showInsuranceOnAppointmentDetails={showInsuranceOnAppointmentDetails}
					showProviderResponseApptDetails={showProviderResponseApptDetails}
					showProviderResponsePatientHistory={showProviderResponsePatientHistory}
					showReasonForVisitApptDetails={showReasonForVisitApptDetails}
					togglePastModal={togglePastModal}
					togglePreviousAppointmentDetailsModal={togglePreviousAppointmentDetailsModal}
					verifyFuture={verifyFuture}
					isAppointmentCancelled={props.isCancelled}
				/>
			)}
		</>
	);
}

export default withRouter(AppointmentDetailsView);
